import { ctaPreFooterData } from './cta-prefooter-data'
import sharedStyles from '../../car-reviews-v2.module.css'
import styles from './cta-prefooter.module.css'
import cx from 'classnames'
import { CtaButton } from '../cta-button'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { Datadog } from '@cinch-nx/landing-ui-shared'

const { Actions, Context } = Datadog

export const CtaPreFooter: React.FC = () => {
  const ctaButton = 'View all car reviews'
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      eventName: `Car Review - ${ctaButton}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'view all car reviews',
          label: 'cta',
        },
      },
    })

    datadogRum.addAction(Actions.CLICK_CAR_REVIEW_CTA_PREFOOTER, {
      service: Context.CAR_REVIEW,
      squad: Context.SQUAD,
      page: window.location.pathname,
      value: 'cta prefooter',
    })
  }

  return (
    <section className={cx(sharedStyles.inner, styles.ctaPreFooterContainer)}>
      <div className={styles.ctaPreFooterTextWrapper}>
        <h2 className={styles.ctaPreFooterTitle}>{ctaPreFooterData.title}</h2>
        <p className={styles.ctaPreFooterDataBody}>{ctaPreFooterData.body} </p>
      </div>

      <CtaButton
        href={`/reviews`}
        className={styles.ctaButton}
        onClick={() => handleClick()}
      >
        {ctaButton}
      </CtaButton>
    </section>
  )
}
